module.exports = __webpack_public_path__ + "img/parthner-2.b383dac5.svg";